import { ExecuteImportResult } from '@/components/DataIngestion/actions/import/import';
import { Button, useModal } from '@payloadcms/ui';

import './styles.scss';

interface ImportResultProps {
  importResult: ExecuteImportResult;
  modalSlug: string;
}

const ImportResult = ({ importResult, modalSlug }: ImportResultProps) => {
  const { closeModal } = useModal();

  return (
    <div className="fv-import-result">
      <h2>Import summary</h2>
      <p>Updated {importResult.documentsUpdated} documents successfully as drafts.</p>
      {importResult.documentsFailed > 0 && <p>Failed to import {importResult.documentsFailed} documents. See the errors below.</p>}
      {importResult.errors.length > 0 && (
        <div>
          <ul>
            {importResult.errors.map((error) => (
              <li key={error.documentId}>
                <strong>
                  Document ID: {error.documentId} {error.locale && `(Locale: ${error.locale})`}
                </strong>
                <br />- Error: {error.error}
              </li>
            ))}
          </ul>
        </div>
      )}
      <div className="fv-import-result__actions">
        <Button onClick={() => closeModal(modalSlug)}>Close</Button>
      </div>
    </div>
  );
};

export default ImportResult;
